import * as TYPE from '../types';
const initialState = {
  user: null,
  roleName: '',
  permissions: null,
};
export const userReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.USER_DATA_FOUND:
      return {
        ...state,
        user: action.payload.resultUser,
      };

    case TYPE.USER_DATA_ROLE:
      return {
        ...state,
        roleName: action.payload.roleName,
        permissions: action.payload.rolePermissions,
      };
    case TYPE.USER_DATA_RESET:
      return {
        user: null,
        roleName: '',
        permissions: null,
      };

    default:
      return state;
  }
};
